import './index.scss';

const ProjectCard = (props) => {
  return (
    <>
      <a className='project-link' href={props.url} target='_blank' rel='noreferrer'>
        <div className='project-card-container'>
          <div className='title'>
            {props.title}
          </div>
          <div className='content'>
            <div className='cover'>
              <img src={props.cover} alt='cover'/>
            </div>
            <div className='text'>
              <div className='description'>
                <p>
                {props.description}
                </p>
              </div>
              <div className='stack'>
                <p>{props.stack}</p>
              </div>
            </div>
          </div>
        </div>
      </a>
    </>
  )
}

export default ProjectCard;